/*       */

import { gql } from '@apollo/client';

import { workspaceFields, classWorkspaceFields } from 'graphql/entities/entities/loadEntityWorkspacesQuery';

export default type => gql`
    mutation unshareEntityWithWorkspacesMutation($id: ID!, $workspaces: [ID]!) {
        result: ${type === 'class' ? 'unshareClassWithWorkspaces' : 'unshareEntityWithWorkspaces'}(id: $id, workspaces: $workspaces${
    type === 'class' ? '' : `, type: "${type}"`
}) {
          ${type === 'class' ? classWorkspaceFields : workspaceFields}
        }
    }
`;
